export class VisaLandingPageController {
  static $inject = [
    "$rootScope",
  ];

  constructor(
    private $rootScope: any,
  ) { }
}
